module.exports = __webpack_public_path__ + "static/media/Ship-Meraviglia-MSC_YC.5ebbc786.webp";